import { Amplify, Auth } from 'aws-amplify';
// import $ from 'jquery';

const config = require('./swift-configs.js');
const apiConfig = config[window.location.hostname].API;

const configpubID = config[window.location.hostname]['Auth']['pubID'];

let doing_forgot_password = false;
let doing_sign_in = false;
let doing_sign_up = false;
let doing_new_password_required = false;

 // Constants for cookie names, local storage keys, and other magic strings
 const COOKIE_NAME_LOGGED_IN = 'swiftCognitoHasLoggedIn';
 const COOKIE_NAME_SWIFT_SESSION_COUNT = 'swiftsessioncognito'; // same as in swift news theme
 const LOCAL_STORAGE_BOOKMARKS =  configpubID + 'bookmarkedPosts';
 const LOCAL_STORAGE_PAGE_VIEWS = configpubID + 'pageViews';
 const LOCAL_STORAGE_READING_HISTORY = configpubID + 'readingHistorySetting';

 let SWIFT_DEBUG_LOGGING = false;

// SwiftCognito class to encapsulate authentication and user management functionality
class SwiftCognito {
    constructor() {

        // Initialize Amplify
        this.configureAmplify();
      
        // Check for debugging cookie called swiftdebug, if true, enable debug logging
        // if the url contains the query string swiftdebug=true, set a cookie to enable debug logging to expire in 14 days
        if (window.location.href.toLowerCase().includes('swiftdebug=true')) {
            this.setCookie('swiftdebug', 'true', 365);
            SWIFT_DEBUG_LOGGING = true;
        }
        SWIFT_DEBUG_LOGGING ? console.log('SWIFT_DEBUG_LOGGING', SWIFT_DEBUG_LOGGING) : null;
        
        // Cache frequently used DOM elements
        this.dom = {};
        this.cacheDomElements();

        // Initialize swiftsessioncognito cookie
        // this.initSwiftSessionCookie();

        // Update dom
        this.updateDom();

        // Initialize Hub
        // this.initHub();

        // Attach event listeners
        this.attachEventListeners();

        // Check for existing session and update UI
        this.handleSessionChange();

        // Initialize Viafoura
        this.initializeViafoura();

        // Process any commands in the swiftQ
        this.processSwiftQueue();

        // Initialize reading history tracking
        this.initializeReadingHistory();

        // Initialize authentication page logic
        this.initializeAuthenticationPage();

        // Event listener for window focus to refresh session
        window.addEventListener('focus', this.handleSessionChange.bind(this));

        // load the correct icon for the bookmark button if the user has bookmarked the article
        if( isArticlePage() ) {
          // wait 1 second before updating the bookmark icon
          setTimeout(() => {
            this.updateBookmarkButtonIcon();
          }, 1000);

        }

        if (window.location.pathname.includes('onboarding')) {
          this.setupOnboarding();
        }

    }

//   initSwiftSessionCookie() {
//     // Initialize swiftsessioncognito cookie
//     // check if the swiftsessioncognito cookie exists, if not, set it
//     SWIFT_DEBUG_LOGGING ? console.log('bundle swiftsessioncognito cookie init', this.getCookie('swiftsessioncognito')) : null;
    
//     if (!this.getCookie('swiftsessioncognito')) {
//       this.setSwiftSessionCookie();
//     } else {
//       const swiftSessionCookie = this.getCookie('swiftsessioncognito');
//       SWIFT_DEBUG_LOGGING ? console.log('swiftSessionCookie', swiftSessionCookie) : null;
//   }
// }

//   setSwiftSessionCookie() {
//     // set the swiftsessioncognito cookie to 1
//     document.cookie = "swiftsessioncognito=1&" + (Date.now() + 1800000); // 30 minute sessions
//   }

  cacheDomElements() {
    this.dom.signInButtonDesktop = document.querySelector('#button-signin-desktop');
    this.dom.signInButtonMobile = document.querySelector('#button-signin-mobile');
    this.dom.registerButtonMobile = document.querySelector('#button-register-mobile');
    this.dom.logoutButtonDesktop = document.querySelector('#button-logout-desktop');
    this.dom.logoutButtonMobile = document.querySelector('#button-logout-mobile');
    // this.dom.bookmarkArticle = document.querySelector("#bookmarkArticle");
    this.dom.profileSave = document.querySelector("#profile-save");
    this.dom.profileName = document.querySelector("#profile-name");
    this.dom.profilePostalCode = document.querySelector("#profile-postal_code");

    // Add any other necessary DOM elements
    this.dom.dropdownMenuDesktop = document.querySelector('#button-dropdown-menu-desktop');
    this.dom.profileMobile = document.querySelector('#button-profile-mobile');
    this.dom.bookmarksMobile = document.querySelector('#button-bookmarks-mobile');
    this.dom.newsletterSubscriptionsMobile = document.querySelector('#button-newsletter-subscriptions-mobile');
    this.dom.userBookmarks = document.querySelector('#user-bookmarks');
    this.dom.topicsMobile = document.querySelector('#button-topics-mobile');
    this.dom.historyMobile = document.querySelector('#button-history-mobile');
    this.dom.userProfileLayout = document.querySelector('#layout-user-profile');
    this.dom.mustBeLoggedInDiv = document.querySelector('#must-be-logged-in-div');

    
    // ... other DOM elements (add as needed)
    this.dom.bookmarkTitle = document.querySelector("meta[property='og:title']").getAttribute("content");
    this.dom.bookmarkShortlink = document.querySelector("link[rel='shortlink']").getAttribute("href");

    this.dom.bookmarkthis = document.querySelectorAll(".toggle-bookmark");
    // document.querySelector('#deleteProfile');
    this.dom.deleteProfile = document.querySelector('#deleteProfile');

    //myprofile page
    this.dom.profilePageManageNewsletterSubs = document.querySelector('#myprofile-page-btn-manage-newsletter-subscriptions');
      
    // class-single.php
    this.dom.bookmarkIcons = document.querySelectorAll(".toggle-bookmark > span > svg > use");
  }


  configureAmplify() {
    try {
      Amplify.configure(config[window.location.hostname]);
    } catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error('Error configuring Amplify:', error) : null;
    }
  }


  updateDom(state) {
    if (state === 'signin') {
      this.dom.signInButtonDesktop?.classList.add('d-none');
      this.dom.signInButtonMobile?.classList.add('d-none');
      this.dom.registerButtonMobile?.classList.add('d-none');
      this.dom.logoutButtonDesktop?.classList.remove('d-none');
      this.dom.dropdownMenuDesktop?.classList.remove('d-none');
      this.dom.logoutButtonMobile?.classList.remove('d-none');
      this.dom.profileMobile?.classList.remove('d-none');
      this.dom.bookmarksMobile?.classList.remove('d-none');
      this.dom.newsletterSubscriptionsMobile?.classList.remove('d-none');
      this.dom.topicsMobile?.classList.remove('d-none');
      this.dom.historyMobile?.classList.remove('d-none');
      this.dom.userProfileLayout?.classList.remove('d-none');
      this.dom.mustBeLoggedInDiv?.classList.add('d-none');
    } else {
      this.dom.signInButtonDesktop?.classList.remove('d-none');
      this.dom.signInButtonMobile?.classList.remove('d-none');
      this.dom.registerButtonMobile?.classList.remove('d-none');
      this.dom.logoutButtonDesktop?.classList.add('d-none');
      this.dom.dropdownMenuDesktop?.classList.add('d-none');
      this.dom.logoutButtonMobile?.classList.add('d-none');
      this.dom.profileMobile?.classList.add('d-none');
      this.dom.bookmarksMobile?.classList.add('d-none');
      this.dom.newsletterSubscriptionsMobile?.classList.add('d-none');
      this.dom.topicsMobile?.classList.add('d-none');
      this.dom.historyMobile?.classList.add('d-none');
      this.dom.userProfileLayout?.classList.add('d-none');
      this.dom.mustBeLoggedInDiv?.classList.remove('d-none');
    }
  }

  attachEventListeners() {
    this.dom.signInButtonDesktop?.addEventListener('click', this.login.bind(this));
    this.dom.signInButtonMobile?.addEventListener('click', this.login.bind(this));
    this.dom.registerButtonMobile?.addEventListener('click', this.register.bind(this));
    this.dom.logoutButtonDesktop?.addEventListener('click', this.logout.bind(this));
    this.dom.logoutButtonMobile?.addEventListener('click', this.logout.bind(this));
    // this.dom.bookmarkArticle?.addEventListener("click", this.toggleBookmark.bind(this));
    this.dom.profileSave?.addEventListener("click", this.updateOpenIDProfile.bind(this));
    this.dom.deleteProfile?.addEventListener("click", this.deleteProfile.bind(this));
    
    this.dom.profilePageManageNewsletterSubs?.addEventListener("click", this.manageNewsletterSubscriptions.bind(this));
    window.addEventListener('focus', this.handleSessionChange.bind(this));
    
    // for each this.dom.bookmarkthis
    for (let i = 0; i < this.dom.bookmarkthis.length; i++) {
      this.dom.bookmarkthis[i].addEventListener("click", this.toggleBookmark.bind(this));
    }

    // ... other event listeners (add as needed)
  }

  async manageNewsletterSubscriptions() {
    const user = await Auth.currentAuthenticatedUser();
    const email = user.attributes.email;
    const url = '/newsletter-subscriptions/?email=' + email;
    window.location.href = url;
  }

  // Handle session changes and update UI accordingly
  async handleSessionChange() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        this.onSignIn(user);
      } else {
        this.onSignOut();
      }
    } catch (error) {
    //   SWIFT_DEBUG_LOGGING ? console.error('Error checking session:', error) : null;
      this.onSignInError(error);
    }
  }

//   async initHub() {
//     const listener = (data) => {

//         switch (data.payload.event) {
//             case 'configured':
//                 // SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Auth module is configured') : null;
//                 break;
//             case 'auth':
//                 const user = payload.data;
//                 // SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Listener user auth', user) : null;
//                 break;
//             case 'autoSignIn':
//                 // SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Auto sign in successful', data.payload) : null;
//                 loginViafoura();
//                 // SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Auto sign in successful', data.payload) : null;
//                 Swiftcognito.loggedIn = 'yes';
//                 sendChartbeatUserLoggedIn('lgdin');
//                 goToLastViewedPageBeforeLogin();
//                 setCookie('swiftCognitoHasLoggedIn', 'true', 365);
                
//                 break;
//             case 'autoSignIn_failure':
//                 SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Auto sign in failed') : null;
//                 Swiftcognito.loggedIn = 'no';
//                 sendChartbeatUserLoggedIn('anon');
//                 setCookie('swiftCognitoHasLoggedIn', 'false', 365);
//                 break;
//             case 'signIn_failure':
//                 // SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Listener user sign in failed', data.payload) : null;
//                 Swiftcognito.loggedIn = 'no';
//                 sendChartbeatUserLoggedIn('anon');
//                 setCookie('swiftCognitoHasLoggedIn', 'false', 365);
//                 break;
//             case 'signIn':
//                 // Set this so we know the user has logged in at least once with a registered account, this means don't log them in anonymously. It gets set to true when the user logs in with a registered account.

//                 loginViafoura();
//                 Swiftcognito.loggedIn = 'yes';
//                 sendChartbeatUserLoggedIn('lgdin');
//                 goToLastViewedPageBeforeLogin();
//                 setCookie('swiftCognitoHasLoggedIn', 'true', 365);
//                 break;
//             case 'signIn_failure':
//                 // SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Listener user sign in failed', data.payload) : null;
//                 Swiftcognito.loggedIn = 'no';
//                 logoutViafoura();
//                 sendChartbeatUserLoggedIn('anon');
//                 setCookie('swiftCognitoHasLoggedIn', 'false', 365);
//                 break;
//             case 'signUp':
//                 // SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Listener user signed up') : null;
//                 break;
//             case 'signUp_failure':
//                 SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Listener user sign up failed', data.payload) : null;
//                 break;
//             case 'confirmSignUp':
//                 // SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Listener user confirmation successful') : null;
//                 break;
//             case 'completeNewPassword_failure':
//                 SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Listener user did not complete new password flow', data.payload) : null;
//                 break;
//             case 'forgotPassword':
//                 // SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Password recovery initiated') : null;
//                 break;
//             case 'forgotPassword_failure':
//                 SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Password recovery failed') : null;
//                 break;
//             case 'forgotPasswordSubmit':
//                 // SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Ppassword confirmation successful') : null;
//                 break;
//             case 'forgotPasswordSubmit_failure':
//                 SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Password confirmation failed') : null;
//                 break;
//             case 'tokenRefresh':
//                 // SWIFT_DEBUG_LOGGING ? console.info('token refresh succeeded') : null;
//                 // SWIFT_DEBUG_LOGGING ? console.info('data.payload', data.payload) : null;
//                 loginViafoura();
//                 sendChartbeatUserLoggedIn('lgdin');
//                 setCookie('swiftCognitoHasLoggedIn', 'true', 365);
//                 break;
//             case 'tokenRefresh_failure':
//                 SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Token refresh failed') : null;
//                 logoutViafoura();
//                 sendChartbeatUserLoggedIn('anon');
//                 setCookie('swiftCognitoHasLoggedIn', 'false', 365);
//                 break;
//             case 'cognitoHostedUI':
//                 SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Cognito Hosted UI sign in successful') : null;
//                 loginViafoura();
//                 sendChartbeatUserLoggedIn('lgdin');
//                 setCookie('swiftCognitoHasLoggedIn', 'true', 365);
//                 // checkSendToOnboarding(user);
//                 break;
//             case 'cognitoHostedUI_failure':
//                 SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Cognito Hosted UI sign in failed') : null;
//                 break;
//             case 'customOAuthState':
//                 SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Custom state returned from CognitoHosted UI') : null;
//                 break;
//             case 'customState_failure':
//                 SWIFT_DEBUG_LOGGING ? console.error('Auth listener. Custom state failure') : null;
//                 break;
//             case 'parsingCallbackUrl':
//                 SWIFT_DEBUG_LOGGING ? console.info('Auth listener. Cognito Hosted UI OAuth url parsing initiated') : null;
//                 break;
//             case 'userDeleted':
//                 SWIFT_DEBUG_LOGGING ? console.info('Auth listener. User deletion successful') : null;
//                 logout();
//                 setCookie('swiftCognitoHasLoggedIn', 'false', 365);
//                 break;
//             case 'NotAuthorizedException':
//                 SWIFT_DEBUG_LOGGING ? console.error('Auth listener. User not authorized', data.payload) : null;
//                 signOut();
//                 logoutViafoura();
//                 sendChartbeatUserLoggedIn('anon');
//                 setCookie('swiftCognitoHasLoggedIn', 'false', 365);
//                 break;
//             case 'signOut':
//                 logoutViafoura();
//                 sendChartbeatUserLoggedIn('anon');
//                 // localStorage.removeItem('cognitoIdentityId');
//                 // SWIFT_DEBUG_LOGGING ? console.info('user signed out') : null;
//                 Swiftcognito.loggedIn = 'no';
//                 setCookie('swiftCognitoHasLoggedIn', 'false', 365);
//                 // var rcookie = returnCookie('get');
//                 // returnCookie('delete');
//                 // if (!rcookie) {

//                 // }
//                 // else if ( window.location.href.includes(rcookie) ) {
//                 //     window.location.href = '/';
//                 // }
//                 // else {
//                 //     window.location.href = rcookie;
//                 // }
//                 break;
//         }
//     };
//     Hub.listen('auth', listener);
//   }

  // Actions to perform on user sign in
  
  onSignIn(user) {
    this.loginViafoura();
    this.sendChartbeatUserLoggedIn('lgdin');
    this.setCookie(COOKIE_NAME_LOGGED_IN, 'true');
    this.updateDom('signin');
    this.checkSendToOnboarding(user);
    // ... other actions
  }

  // Actions to perform on user sign out
  onSignOut() {
    // this.logout();
    this.logoutViafoura();
    this.sendChartbeatUserLoggedIn('anon');
    this.setCookie(COOKIE_NAME_LOGGED_IN, 'false');
    this.updateDom('signout');
    window.swiftloggedIn = 'no';
    // ... other actions
  }

  onSignInError(error) {
    // Implement error handling logic
    if (error.code === 'NotAuthorizedException') {
        SWIFT_DEBUG_LOGGING ? console.error('NotAuthorizedException', error) : null;
        this.logout();
    } else if (error.code === 'UserNotConfirmedException') {
        SWIFT_DEBUG_LOGGING ? console.error('UserNotConfirmedException', error) : null;
        // resend the confirmation email
        Auth.resendSignUp(email)
            .then(() => {
                SWIFT_DEBUG_LOGGING ? console.info('Confirmation email resent') : null;
            })
            .catch((error) => {
                SWIFT_DEBUG_LOGGING ? console.error('Error resending confirmation email:', error) : null;
            });
    } else if (error.code === 'UserNotFoundException') {
        SWIFT_DEBUG_LOGGING ? console.error('UserNotFoundException', error) : null;
        this.logout();
    } else {
        SWIFT_DEBUG_LOGGING ? console.error('Error signing in:', error) : null;
    } 
    this.logout();
  }
  
  // --- Authentication Methods ---

  login() {
    window.location.href = '/authentication/';
  }

  register() {
    window.location.href = '/authentication/';
  }

  logout() {
    // this.logoutViafoura();
    Amplify.Auth.signOut()
      .then(() => {
        // this.onSignOut();
        this.logoutViafoura();
        this.sendChartbeatUserLoggedIn('anon');
        window.swiftloggedIn = 'no';
        this.updateDom('signout');
        this.setCookie(COOKIE_NAME_LOGGED_IN, 'false');
      })
      .catch((error) => {
        SWIFT_DEBUG_LOGGING ? console.error('Error signing out:', error) : null;
      });
  }


  async getProfileData() {
    SWIFT_DEBUG_LOGGING ? console.info('try getProfileData') : null;
    try {
        const user = await Auth.currentAuthenticatedUser();
        const attributes = await Auth.userAttributes(user);

        const name = attributes.find(attribute => attribute.Name === 'name');
        if (name && name.Value) {
            this.dom.profileName.value = name.Value;
        }
        
        const address = attributes.find(attribute => attribute.Name === 'address');
        if (address && address.Value) {
          const parsedAddress = JSON.parse(address.Value);
          const postalCode = parsedAddress.address.postal_code || '';
          this.dom.profilePostalCode.value = postalCode;
        }

    } catch (error) {
        SWIFT_DEBUG_LOGGING ? console.error('Error getting profile data:', error) : null;
    }
}


  // --- Viafoura Integration ---

  initializeViafoura() {
    window.vfQ = window.vfQ || [];
    window.vfQ.push(() => {
        window.vf.$subscribe('login', 'failure', (errorContext, loginContext) => {
            SWIFT_DEBUG_LOGGING ? console.error('Viafoura login failure:', errorContext, loginContext) : null;
        });
        window.vf.$subscribe('login/openIdConnect', 'success', function (errorContext, loginContext) {
            SWIFT_DEBUG_LOGGING ? console.info('Viafoura login success', errorContext, loginContext) : null;
        });
        window.vf.$subscribe('login/openIdConnect', 'failure', function (errorContext, loginContext) {
            SWIFT_DEBUG_LOGGING ? console.error('Viafoura login failure', errorContext, loginContext) : null;
        });
        window.vf.$subscribe('login/failure', function (errorContext, loginContext) {
            SWIFT_DEBUG_LOGGING ? console.error('Viafoura login failure', errorContext, loginContext) : null;
        });
        window.vf.$subscribe('login/success', function (errorContext, loginContext) {
            SWIFT_DEBUG_LOGGING ? console.info('Viafoura login success', errorContext, loginContext) : null;
        });
        window.vf.$subscribe('logout', 'success', function (errorContext, loginContext) {
            SWIFT_DEBUG_LOGGING ? console.info('Viafoura logout success', errorContext, loginContext) : null;
        });

      window.vf.$prepublish((channel, event, ...args) => {
        if (channel === "authentication" && event === "required") {
          this.ensureAuthenticated();
          return false;
        }
        return { channel, event, args };
      });
    });
  }

  loginViafoura() {
    try {
      const session = Auth.currentSession();
      session.then((result) => {
        const jwtToken = result.getIdToken().getJwtToken();
        window.vfQ = window.vfQ || [];
        window.vfQ.push(() => {
          window.vf.session.login.openIdConnect(jwtToken);
        });
      });
    } catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error('Error logging in to Viafoura:', error) : null;
    }
  }

  logoutViafoura() {
    try {
      window.vfQ = window.vfQ || [];
      window.vfQ.push(() => {
        window.vf.session.logout();
      });
    } catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error('Error logging out of Viafoura:', error) : null;
    }
  }

  ensureAuthenticated() {
    Auth.currentAuthenticatedUser()
      .then(() => {
        this.loginViafoura();
      })
      .catch(() => {
        if (confirm('You must be logged in to continue. Click OK to login or register.')) {
          this.login();
        }
      });
  }

  // --- User Data Management ---

  async updateOpenIDProfile() {

    this.dom.profileName.disabled = true;
    this.dom.profilePostalCode.disabled = true;
    this.dom.profileSave.disabled = true;

    try {
      const user = await Auth.currentAuthenticatedUser();
      const postalCode = this.dom.profilePostalCode.value;
      // don't pass empty strings to the API as it will overwrite existing values with empty strings
      const address = JSON.stringify({
        address: {
            postal_code: postalCode,
        //   formatted: "",
        //   street_address: "",
        //   locality: "",
        //   region: "",
        //   country: "",
        },
      });

      const attributes = {
        name: this.dom.profileName.value,
        address: address,
      };

      await Auth.updateUserAttributes(user, attributes);
      SWIFT_DEBUG_LOGGING ? console.info('OpenID profile updated successfully') : null;

      this.dom.profileName.disabled = false;
      this.dom.profilePostalCode.disabled = false;
      this.dom.profileSave.disabled = false;

      this.dom.profileName.css("background-color", "#c3e6cb");
      this.dom.profilePostalCode.css("background-color", "#c3e6cb");
      
      // Provide feedback to the user
      // wait one second and then remove the green background
      setTimeout(() => {
        // fade out
        this.dom.profileName.css("background-color", "#fff");
        this.dom.profilePostalCode.css("background-color", "#fff");
      });
      
    } catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error('Error updating OpenID profile:', error) : null;
      // Handle error, e.g., display an error message
      this.dom.profileName.disabled = false;
      this.dom.profilePostalCode.disabled = false;
      this.dom.profileSave.disabled = false;
      return false;
    }
  }

  // --- Bookmark Management ---

  async toggleBookmark() {
    SWIFT_DEBUG_LOGGING ? console.info('swift Bookmark button clicked') : null;
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        SWIFT_DEBUG_LOGGING ? console.info('swift Bookmark User is logged in') : null;
        this.storeBookmarkLocally();
        // Store bookmark in DynamoDB
        // ... implementation
      } else {
        this.storeBookmarkLocally();
      }
    } 
    catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error('Error toggling bookmark:', error) : null;
      if (confirm('You must be logged in to bookmark stories. Click OK to login or register.')) {
        window.location.href = '/authentication/';
      }
    }
  }
  

  storeBookmarkLocally() {
    const bookmarkTitle = this.dom.bookmarkTitle;
    const bookmarkShortlink = this.dom.bookmarkShortlink;
    const postId = bookmarkShortlink.split("=")[1];
    const post = { postId, bookmarkTitle, bookmarkShortlink };

    let bookmarkedPosts = JSON.parse(localStorage.getItem(LOCAL_STORAGE_BOOKMARKS)) || [];
    const postIndex = bookmarkedPosts.findIndex((p) => p.postId === postId);
    SWIFT_DEBUG_LOGGING ? console.info('swift bookmark post', post) : null;

      if (postIndex === -1) 
      {
        bookmarkedPosts.push(post);
        this.dom.bookmarkIcons.forEach((icon) => {
          icon.setAttribute("xlink:href", "#fa-bookmark");
          icon.setAttribute("class", "fa-bookmark swift-icon-bookmark");
        });

      }
      else
      {
        bookmarkedPosts.splice(postIndex, 1);
        this.dom.bookmarkIcons.forEach((icon) => {
          icon.setAttribute("xlink:href", "#fa-bookmark-o");
          icon.setAttribute("class", "fa-bookmark-o swift-icon-bookmark-o");
        });
      }
      localStorage.setItem(LOCAL_STORAGE_BOOKMARKS, JSON.stringify(bookmarkedPosts));
  }

  async updateBookmarkButtonIcon() {

    // ... implementation for updating the bookmark button UI
    let bookmarkedPosts = JSON.parse(localStorage.getItem(LOCAL_STORAGE_BOOKMARKS)) || [];
    
    const bookmarkTitle = this.dom.bookmarkTitle;
    const bookmarkShortlink = this.dom.bookmarkShortlink;
    const shortlink = this.dom.bookmarkShortlink;
    const postId = shortlink.split("=")[1];
    const post = { postId, bookmarkTitle, bookmarkShortlink };

    const postIndexInBookmarkedPosts = bookmarkedPosts.findIndex((p) => p.postId === postId);
    // if this post is already bookmarked, update the icon

    if (postIndexInBookmarkedPosts !== -1) {
    {
      bookmarkedPosts.push(post);
      this.dom.bookmarkIcons.forEach((icon) => {
        icon.setAttribute("xlink:href", "#fa-bookmark");
        icon.setAttribute("class", "fa-bookmark swift-icon-bookmark");
      });
    }


    SWIFT_DEBUG_LOGGING ? console.info('swift bookmark post is already bookmarked', post) : null;
  } 

    // // $("#bookmarkthis > span > svg > use").attr("xlink:href", "#fa-bookmark-o");
    // // $("#bookmarkthis > span > svg > use").attr("class", "fa-bookmark-o swift-icon-bookmark-o");
    // this.dom.bookmarkthisIcon = document.querySelector("#bookmarkthis > span > svg > use");

    // if (postIndexInBookmarkedPosts === -1) {
    //   bookmarkedPosts.push(post);
    //   this.dom.bookmarkthisIcon.setAttribute("xlink:href", "#fa-bookmark-o");
    //   this.dom.bookmarkthisIcon.setAttribute("class", "fa-bookmark-o swift-icon-bookmark-o");
    // } else {
    //   bookmarkedPosts.splice(postIndexInBookmarkedPosts, 1);
    //   this.dom.bookmarkthisIcon.setAttribute("xlink:href", "#fa-bookmark");
    //   this.dom.bookmarkthisIcon.setAttribute("class", "fa-bookmark swift-icon-bookmark");
    // }

  }

  async loginFromWeb(email, password) {
    // Use Amplify's Auth module to sign in the user with email and password
    Auth.signIn(email, password)
        .then(user => {
            // Sign in successful, user object is available here
            SWIFT_DEBUG_LOGGING ? console.info('Successfully signed in:', user) : null;
            return user;
            window.location.href = '/';
        })
        .catch(error => {
            // Handle sign in error here
            SWIFT_DEBUG_LOGGING ? console.error('Sign in error:', error) : null;
            document.querySelector('#loginError').innerHTML = error.message;
            return error;

        });
}


  async registerFromWeb(email, password) {
    // Use Amplify's Auth module to sign in the user with email and password
    Auth.signUp({
        username: email,
        password: password,
        attributes: {
            email: email
        },
        autoSignIn: { // optional - enables auto sign in after user is confirmed
            enabled: true,
        }
    })
        .then(user => {
            // Sign in successful, user object is available here
            SWIFT_DEBUG_LOGGING ? console.info('Successfully signed up:', user) : null;
        })
        .catch(error => {
            // Handle sign in error here
            SWIFT_DEBUG_LOGGING ? console.error('Sign up error:', error) : null;
        });
}


  // --- Reading History Management ---

  initializeReadingHistory() {
    if (this.isArticlePage()) {
      this.logPageView();
    }
  }

  isArticlePage() {
    return document.body.classList.contains('single-post');
  }

  logPageView() {
    // check if the user turned off reading history tracking in their user profile
    if (localStorage.getItem(LOCAL_STORAGE_READING_HISTORY) !== 'false') {
      const pageTitle = document.title.split('|')[0].trim();
      const pageUrl = window.location.href.split('?')[0].split('#')[0];

      const dateTime = new Date();
      const pageView = { title: pageTitle, url: pageUrl, dateTime: dateTime };

      let pageViews = JSON.parse(localStorage.getItem(LOCAL_STORAGE_PAGE_VIEWS)) || [];
      // check if the page is already in the array and if so, move it to the end
      const index = pageViews.findIndex((p) => p.url === pageUrl);
      if (index !== -1) {
        pageViews.splice(index, 1);
      } else {
        pageViews.push(pageView);
        localStorage.setItem(LOCAL_STORAGE_PAGE_VIEWS, JSON.stringify(pageViews));
      }
    }
  }

  // --- Helper Methods ---
  setCookie(name, value, days) {
    // ... implementation for setting cookies
    var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // this is 1 year
            expires = "; expires=" + date.toUTCString();
        }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  getCookie(name) {
    // ... implementation for getting cookies
    var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) {
                // SWIFT_DEBUG_LOGGING ? console.info('got cookie', c.substring(nameEQ.length, c.length) : null;);
                return c.substring(nameEQ.length, c.length);
            }
        }
    return null;
  }

  sendChartbeatUserLoggedIn(userType) {
    // ... implementation for sending Chartbeat data
    userType == 'lgdin' ? userType = 'lgdin' : userType = 'anon';
    var _cbq = window._cbq = (window._cbq || []);
    _cbq.push(['_acct', userType]);
  }

  

  async checkSendToOnboarding(user) {

      const attributes = await Auth.userAttributes(user);
      const email = user.attributes.email;
      const createdAt = attributes.find(attribute => attribute.Name === 'custom:createdAt');
      const shouldWeSendToOnboarding = attributes.find(attribute => attribute.Name === 'custom:sendToOnboarding');
      const name = attributes.find(attribute => attribute.Name === 'name');

      // if the user doesn't have a createdAt attribute, set it now
      if (!createdAt || createdAt == 'undefined' || createdAt == 'null') {
          SWIFT_DEBUG_LOGGING ? console.info('no createdAt value, set it now and then send to onboarding') : null;
          await Auth.updateUserAttributes(user, {
              'custom:createdAt': new Date().toISOString(),
              'custom:sendToOnboarding': 'true'
          });
          // they just signed in for the first time, so get their name during onboarding
          // are we on the onboarding page? if so, don't redirect
          if (!window.location.href.includes('onboarding')) {
            window.location.href = '/onboarding/?email=' + email;
          }
          // 
      } else {
          // check if the user has a name
          if (!name || name == 'undefined' || name == 'null') {
              SWIFT_DEBUG_LOGGING ? console.info('swift User has not set their name, send to onboarding') : null;
              // get their name during onboarding
              // are we on the onboarding page? if so, don't redirect
              if (!window.location.href.includes('onboarding')) {
                window.location.href = '/onboarding/?email=' + email;
              }
          }

          // check if the user should be sent to onboarding because a flag was set by admin. It's possible to get into a loop here if the user doesn't finish onboarding to delete that value.
          if (shouldWeSendToOnboarding && shouldWeSendToOnboarding.Value == 'true') {
              SWIFT_DEBUG_LOGGING ? console.info('Swift send to onboarding because flag was set manually') : null;
              // are we on the onboarding page? if so, don't redirect
              if (!window.location.href.includes('onboarding')) {
                window.location.href = '/onboarding/?email=' + email;
              }
          }
      } // end set attribute: createdAt


  }

  
  // --- Swift Queue Processing ---
// Ensure window.swiftQ exists and is an array
// This gets loaded before the main script
// JavaScript in the swift news theme can be added to the window.swiftQ array and then get processed after this bundle.min.js loads
  processSwiftQueue() {
    window.swiftQ = window.swiftQ || [];
    (function () {
      const queue = window.swiftQ;
      window.swiftQ = {
        queue: queue,
        isExecuting: false,
        push: function (command) {
          this.queue.push(command);
          this.process();
        },
        process: async function () {
          if (this.isExecuting) return;
          this.isExecuting = true;
          while (this.queue.length > 0) {
            const command = this.queue.shift();
            try {
              await command();
            } catch (error) {
              SWIFT_DEBUG_LOGGING ? console.error("Error executing command:", error) : null;
            }
          }
          this.isExecuting = false;
        },
      };
      window.swiftQ.process();
    })();
  }

  // --- Authentication Page Logic ---

  initializeAuthenticationPage() {
  if (window.location.pathname.includes('authentication')) {
      this.setupAuthenticationForm();

      // if doing_forgot_password = true, then listen for the enter key to submit the form
      document.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
            if (doing_forgot_password) {
              document.querySelector('#forgotPasswordResetButton').click();
            }
            if (doing_sign_in) {
              document.querySelector('#signInButton').click();
            }
            if (doing_sign_up) {
              document.querySelector('#signUpButton').click();
            }
            if (doing_new_password_required) {
              document.querySelector('#newPasswordRequiredButton').click();
            }
        }
      });

  }
}

  setupAuthenticationForm() {
    // Cache DOM elements specific to the authentication page
    const navHomeTab = document.querySelector('#nav-home-tab');
    const navSignUpTab = document.querySelector('#nav-signup-tab');
    const signInForm = document.querySelector('#signInForm');
    const signUpForm = document.querySelector('#signUpForm');
    const newPasswordRequiredForm = document.querySelector('#newPasswordRequiredForm');
    const signInButton = document.querySelector('#signInButton');
    const signUpButton = document.querySelector('#signUpButton');
    const newPasswordRequiredButton = document.querySelector('#newPasswordRequiredButton');
    const signInEmailInput = document.querySelector('#signInEmailInput');
    const signInPasswordInput = document.querySelector('#signInPasswordInput');
    const forgotPasswordLink = document.querySelector('#forgotPasswordLink');
    const forgotPasswordResetButton = document.querySelector('#forgotPasswordResetButton');
    const signUpEmailInput = document.querySelector('#signUpEmailInput');
    const signUpPasswordInput = document.querySelector('#signUpPasswordInput');
    const newPasswordRequiredInput = document.querySelector('#newPasswordRequiredInput');
    const passwordResetConfirm = document.querySelector('#passwordResetConfirm');
    const passwordResetPasswordInput = document.querySelector('#passwordResetPasswordInput');
    const requsetANewVerificationLink = document.querySelector('#requsetANewVerificationLink');

    // ... other DOM elements (add as needed)

    // Show/hide password fields
    const passwordRevealSignIn = document.querySelector('#passwordRevealSignIn');
    const passwordRevealSignUp = document.querySelector('#passwordRevealSignUp');
    const passwordRevealReset = document.querySelector('#passwordRevealReset');
    const passwordRevealNewPasswordRequired = document.querySelector(
      '#passwordRevealnewPasswordRequired'
    );

    passwordRevealSignIn.classList.remove('d-none');
    passwordRevealSignUp.classList.remove('d-none');
    passwordRevealReset.classList.remove('d-none');

    // Tooltips
    const tooltipTriggerList = [...document.querySelectorAll('[data-bs-toggle="tooltip"]')];
    tooltipTriggerList.forEach((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));

    // Check for signup code in URL
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('signup_code') && urlParams.get('signup_email')) {
      this.doSignUpCodeConfirm(urlParams);
    }

    // Event listeners for tab switching
    navHomeTab?.addEventListener('click', () => {
      signInPasswordInput.classList.remove('d-none');
      signInEmailInput.classList.remove('d-none');
      signInButton.classList.remove('d-none');
      forgotPasswordLink.classList.remove('d-none');
      forgotPasswordResetButton.classList.add('d-none');
      signInForm.classList.remove('d-none');
      passwordRevealSignIn.classList.remove('d-none');
      newPasswordRequiredForm.classList.add('d-none');
      signInButton.disabled = false;
    });

    navSignUpTab?.addEventListener('click', () => {
      signUpForm.classList.remove('d-none');
      signUpEmailInput.classList.remove('d-none');
      signUpPasswordInput.classList.remove('d-none');
      signUpForm.classList.remove('d-none');
      signUpButton.classList.remove('d-none');
      passwordRevealSignUp.classList.remove('d-none');
      newPasswordRequiredForm.classList.add('d-none');
      signUpButton.disabled = false;
    });

    // Event listeners for form submissions
    if( document.querySelector('#forgotPasswordResetButton').classList.contains('d-none') ) {
      signInForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.handleSignIn(signInEmailInput.value, signInPasswordInput.value);
      });
    }

    signUpForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.handleSignUp(signUpEmailInput.value, signUpPasswordInput.value);
    });

    newPasswordRequiredForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.handleNewPasswordRequired(newPasswordRequiredInput.value);
    });

    // Event listener for forgot password link
    forgotPasswordLink?.addEventListener('click', () => {
      SWIFT_DEBUG_LOGGING ? console.info('Clicked forgot password link') : null;
      doing_forgot_password = true;
      forgotPasswordResetButton.classList.remove('d-none');
      forgotPasswordLink.classList.add('d-none');
      signInButton.classList.add('d-none');
      signInPasswordInput.classList.add('d-none');
      passwordRevealSignIn.classList.add('d-none');
      passwordRevealReset.classList.add('d-none');
    });

    // Event listener for forgot password reset button
    forgotPasswordResetButton?.addEventListener('click', async (event) => {
      event.preventDefault();
      SWIFT_DEBUG_LOGGING ? console.info('Clicked forgot password submit button') : null;
      const email = signInEmailInput.value;
      document.querySelector('#signInError').innerText = '';
      if (!email) {
        document.querySelector('#signInError').innerText = 'Please enter your email address first.';
        return;
      }
      try {
        await Auth.forgotPassword(email);
        SWIFT_DEBUG_LOGGING ? console.info('Password reset code sent successfully', email) : null;
        document.querySelector('#signInError').innerText =
          'Sent. Please click on the link in your email to reset your password.';
        document.querySelector('#signInError').classList.add('text-success');
        document.querySelector('#signInError').classList.remove('text-danger');
      } catch (error) {
        this.handleForgotPasswordError(error);
      }
    });

    // Event listener for password reset confirmation
    // passwordResetConfirm?.addEventListener('click', async (event) => {
    //   event.preventDefault();
    //   SWIFT_DEBUG_LOGGING ? console.info('Clicked forgot password submit button to confirm new code and enter new password') : null;
    //   this.processForgotPasswordLink(
    //     passwordResetPasswordInput.value,
    //     urlParams.get('email'),
    //     urlParams.get('forgot_password_code')
    //   );
    // });

    // Event listener for requesting a new verification link
    requsetANewVerificationLink?.addEventListener('click', async (event) => {
      event.preventDefault();
      SWIFT_DEBUG_LOGGING ? console.info('Clicked send new verification link') : null;
      this.sendNewVerificationLink(signInEmailInput.value);
    });

    // Event listeners for password reset confirm
    // https://www.aspentimes.com/authentication/?forgot_password_code=438868&username=a148cbe6-eef6-4cc9-9fdb-44e4e84f2170&email=mferrari@swiftcom.com&utm_medium=email&utm_source=reg&utm_content=resetPass&utm_campaign=AT_Reg
    if (!urlParams.has('forgot_password_code') && !urlParams.has('username')) {
        console.info('not doing forgot password');
    } else {
        console.info("Doing forgot password.");
        // add keydown event listener for enter key and click forgotPasswordResetButton button
        // document.addEventListener('keydown', function(event) {
        //   event.preventDefault();
        //   if (event.which === '13') {
        //     document.getElementById('forgotPasswordResetButton').click();
        //   }
        // });        

        const navTabsParent = document.querySelector('#nav-tabs-parent');
        const navTabsContent = document.querySelector('#nav-tabContent');
        navTabsParent.classList.add('d-none');
        navTabsContent.classList.add('d-none');
        passwordResetForm.classList.remove('d-none');
        passwordResetEmailGroup.classList.remove('d-none');
        passwordResetPasswordGroup.classList.remove('d-none');
        passwordResetError.classList.remove('d-none');
        passwordResetError.innerText = 'Please enter your new password.';
        passwordResetPasswordInput.classList.remove('d-none');
        passwordResetConfirm.classList.remove('d-none');
        passwordResetEmailGroup.classList.remove('d-none');

        passwordResetConfirm.addEventListener('click', async (event) => {
          const newPassword = passwordResetPasswordInput.value;
          const email = urlParams.get('email');
          const username = urlParams.get('username');
          const code = urlParams.get('forgot_password_code');
          this.processForgotPasswordLink(newPassword, email, code);
        });
    }

    // if the url contains code and username
    if (!urlParams.has('force_email') && !urlParams.has('force_password')) {
        console.info('no force email or password');
    } else {
        console.info('have force email or password');
        signInEmailInput.value = urlParams.get('force_email');
        signInPasswordInput.value = urlParams.get('force_password');
        signInError.innerText = "We've filled the form with your email and temporary password. Please click 'Sign In' to continue and set a new password.";
        signInError.classList.remove('text-danger');
        signInError.classList.add('text-success');
        
        signInError.classList.remove('d-none');
        
        console.info("have both urlParams for force password change, show login and disable email and password input fields, add mesage that user should click login to reset their password. Change sign in button to say 'reset password'");
        console.info('force email and password', urlParams.get('force_email'), urlParams.get('force_password'));
        
    }
  }

  async handleSignIn(email, password) {
    const signInButton = document.querySelector('#signInButton');
    document.querySelector('#signInError').innerText = '';

    signInButton.disabled = true;
    signInButton.innerHTML =
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Signing in...';

    if (!email) {
      document.querySelector('#signInError').innerText = 'Please enter your email address.';
      this.resetSignInButton();
      return;
    }
    if (!password) {
      // check if the user is doing a password reset instead
      if (document.querySelector('#forgotPasswordResetButton').classList.contains('d-none')) {
        document.querySelector('#signInError').innerText = 'Please enter your password.';
        this.resetSignInButton();
        return;
      }
    }

    try {
      const user = await Auth.signIn(email, password);
      SWIFT_DEBUG_LOGGING ? console.info('Signed in user ', user) : null;

      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.handleNewPasswordRequiredChallenge(user); // because their password is temporary from admin
      } else {
        // Handle other challenge types as needed
        SWIFT_DEBUG_LOGGING ? console.info('No challengeName returned') : null;
        this.goToLastViewedPageBeforeLogin();
      }
    } catch (error) {
      this.handleSignInError(error);
    }
  }

  async handleSignUp(email, password) {
    const signUpButton = document.querySelector('#signUpButton');
    signUpButton.disabled = true;
    signUpButton.innerHTML =
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Working...';

    try {
      const response = await fetch(`/wp-admin/admin-ajax.php?action=check_email&email=${email}`);
      const data = await response.json();
      SWIFT_DEBUG_LOGGING ? console.info(data) : null;
      if (data === 1) {
        signUpButton.innerHTML = 'Sign Up';
        signUpButton.disabled = false;
        document.querySelector('#signUpError').innerText =
          'This email address is not allowed. Temporary emails are not allowed.';
        return;
      }

      try {
        const { user } = await Auth.signUp({
          username: email,
          password: password,
        });
        document.querySelector('#signUpError').innerText =
          'Please click the link in your email. Check your spam folder if you don\'t see it.';
        document.querySelector('#signUpError').classList.remove('text-danger');
        document.querySelector('#signUpError').classList.add('text-success');

        signUpButton.innerHTML = 'Check your email';
        signUpButton.disabled = true;

        this.registerConversion();
      } catch (error) {
        this.handleSignUpError(error);
      }
    } catch {
      SWIFT_DEBUG_LOGGING ? console.error('Signup form fetch failed, continuing...') : null;
    }
  }

  async handleNewPasswordRequired(newPassword) {
    const newPasswordRequiredButton = document.querySelector('#newPasswordRequiredButton');
    newPasswordRequiredButton.disabled = true;
    newPasswordRequiredButton.innerHTML =
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Setting new password...';

    try {
      await Auth.completeNewPassword(this.newPasswordRequiredUser, newPassword);
      SWIFT_DEBUG_LOGGING ? console.info('New password set successfully') : null;
      window.location.href = '/';
    } catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error('Error setting new password:', error) : null;
      document.querySelector('#newPasswordRequiredError').innerText = error.message;
      newPasswordRequiredButton.disabled = false;
      newPasswordRequiredButton.innerHTML = 'Set New Password';
    }
  }

  handleNewPasswordRequiredChallenge(user) {
    const signInForm = document.querySelector('#signInForm');
    const newPasswordRequiredForm = document.querySelector('#newPasswordRequiredForm');
    const newPasswordRequiredError = document.querySelector('#newPasswordRequiredError');
    const newPasswordRequiredInput = document.querySelector('#newPasswordRequiredInput');
    const show_hide_password_newPasswordRequired = document.querySelector(
      '#show_hide_password_newPasswordRequired'
    );
    const passwordRevealNewPasswordRequired = document.querySelector(
      '#passwordRevealnewPasswordRequired'
    );
    const newPasswordRequiredButton = document.querySelector('#newPasswordRequiredButton');

    SWIFT_DEBUG_LOGGING ? console.info('New password required', user.challengeParam) : null;

    signInForm.classList.add('d-none');
    newPasswordRequiredForm.classList.remove('d-none');
    newPasswordRequiredError.innerText = 'Please enter a new password. Six characters minimum.';
    newPasswordRequiredInput.classList.remove('d-none');
    show_hide_password_newPasswordRequired.classList.remove('d-none');
    passwordRevealNewPasswordRequired.classList.remove('d-none');
    newPasswordRequiredButton.classList.remove('d-none');

    this.newPasswordRequiredUser = user;
  }

  async processForgotPasswordLink(newPassword, email, code) {
    SWIFT_DEBUG_LOGGING ? console.info('setting new password', newPassword, email, code) : null;
    document.querySelector('#passwordResetError').innerText = '';

    try {

      const data = await Auth.forgotPasswordSubmit(email, code, newPassword);
      console.log('forgot password submit data', data);
      SWIFT_DEBUG_LOGGING ? console.info('Password reset successfully') : null;
      document.querySelector('#passwordResetError').classList.remove('text-danger');
      document.querySelector('#passwordResetError').classList.add('text-success');
      document.querySelector('#passwordResetError').innerText = 'Password reset successfully. We\'ve signed you in.';

      // Hide password reset form and redirect to homepage
      document.querySelector('#passwordResetPasswordInput').classList.add('d-none');
      document.querySelector('#passwordResetConfirm').classList.add('d-none');
      document.querySelector('#passwordRevealReset').classList.add('d-none');
      await Auth.signIn(email, newPassword);
      window.location.href = '/';
    } catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error(error) : null;
      if (error.code === 'CodeMismatchException') {
        document.querySelector('#passwordResetError').innerText =
          'Your code or link is invalid. Please email support.';
      } else if (error.code === 'ExpiredCodeException') {
        document.querySelector('#passwordResetError').innerText = 'The link you clicked has expired.';
        document.querySelector('#passwordResetError').classList.remove('text-danger');
        document.querySelector('#passwordResetError').classList.add('text-success');
        document.querySelector('#requsetANewVerificationLink').classList.remove('d-none');
      } else {
        document.querySelector('#passwordResetError').innerText = '.' + error.message;
      }
    }
  }

  async sendNewVerificationLink(email) {
    try {
      await Auth.resendSignUp(email);
      SWIFT_DEBUG_LOGGING ? console.info('Confirmation code sent. (if this email is registered)') : null;
      document.querySelector('#passwordResetError').innerText =
        'A new verification link has been sent to your email.';
      document.querySelector('#passwordResetError').classList.remove('text-danger');
      document.querySelector('#passwordResetError').classList.add('text-success');
    } catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error('Error resending confirmation code.', error) : null;
      document.querySelector('#passwordResetError').innerText = error.message;
    }
  }

  handleForgotPasswordError(error) {
    const signInErrorElement = document.querySelector('#signInError');
    let message = error.message;
    if (error.message === 'Username cannot be empty') {
      message = 'Please enter your email address and try again.';
    } else if (
      error.message ===
      'Cannot reset password for the user as there is no registered/verified email or phone_number'
    ) {
      message =
        'Please click the link we just sent you to verify your email address, before requesting a password reset email.';
      Auth.resendSignUp(signInEmailInput.value);
    }
    signInErrorElement.innerText = message;
  }

  resetSignInButton() {
    const signInButton = document.querySelector('#signInButton');
    signInButton.disabled = false;
    signInButton.innerHTML = 'Sign In';
  }

  
  handleSignInError(error) {
    const signInButton = document.querySelector('#signInButton');
    SWIFT_DEBUG_LOGGING ? console.error('Error signing in', error) : null;
    signInButton.disabled = false;
    signInButton.innerHTML = 'Sign In';

    if (error.code === 'UserNotFoundException') {
      this.handleUserNotFound(signInEmailInput.value, signInPasswordInput.value);
    } else if (
      error.code === 'NotAuthorizedException' &&
      error.message === 'Incorrect username or password.'
    ) {
      document.querySelector('#signInError').innerText =
        'Incorrect email address or password.';
    } else if (error.code === 'UserNotConfirmedException') {
      this.handleUserNotConfirmed(signInEmailInput.value);
    } else {
      document.querySelector('#signInError').innerText = error.message;
    }
  }

  handleUserNotFound(email, password) {
    const signUpEmailInput = document.querySelector('#signUpEmailInput');
    const signUpPasswordInput = document.querySelector('#signUpPasswordInput');
    const signUpButton = document.querySelector('#signUpButton');

    document.querySelector('#signUpError').innerText =
      'No account found with that email. Please click Sign Up to register.';
    signUpEmailInput.value = email;
    signUpPasswordInput.value = password;
    signUpButton.disabled = false;
    signUpButton.innerHTML = 'Sign Up';
    document.querySelector('#nav-signup-tab').click();
  }

  async handleUserNotConfirmed(email) {
    try {
      await Auth.resendSignUp(email);
      SWIFT_DEBUG_LOGGING ? console.info('New verification email sent.') : null;
      document.querySelector('#signInError').innerText =
        'Please confirm your email address by clicking the verification link we just sent you.';
      document.querySelector('#signInError').classList.remove('text-danger');
      document.querySelector('#signInError').classList.add('text-success');
    } catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error('Error resending confirmation code', error) : null;
      document.querySelector('#signInError').innerText = error.message;
    }
  }

  handleSignUpError(error) {
    const signUpButton = document.querySelector('#signUpButton');
    signUpButton.innerHTML = 'Sign Up';
    signUpButton.disabled = false;

    if (!signUpEmailInput.value || !signUpPasswordInput.value) {
      document.querySelector('#signUpError').innerText = error.message;
    } else if (error.code === 'UsernameExistsException') {
      SWIFT_DEBUG_LOGGING ? console.error('UsernameExistsException') : null;
      document.querySelector('#signUpError').innerText =
        'This email address is already registered. Please sign in or reset your password.';
    } else {
      SWIFT_DEBUG_LOGGING ? console.error('Error signing up:', error) : null;
      document.querySelector('#signUpError').innerText = error.message;
    }
  }

  async doSignUpCodeConfirm(urlParams) {
    document.querySelector('#signInError').innerText = '';

    const signup_code = urlParams.get('signup_code');
    const signup_email = this.replaceSpaceWithPlus(urlParams.get('signup_email'));

    try {
      console.info(
        'Unencoded signup_email is ' +
          decodeURIComponent(signup_email) +
          ' and the charReplaceEmailSignUp email is ' +
          signup_email
      );
      SWIFT_DEBUG_LOGGING ? console.info('The confirmation code is: ' + signup_code) : null;
      await Auth.confirmSignUp(signup_email, signup_code);
      SWIFT_DEBUG_LOGGING ? console.info('Signup code confirmed successfully') : null;
      this.confirmAccountConversion();
      document.querySelector('#signInError').innerText =
        'Your account has been confirmed. You can now sign in.';
      document.querySelector('#signInError').classList.remove('text-danger');
      document.querySelector('#signInError').classList.add('text-success');
      document.querySelector('#signInEmailInput').value = signup_email;
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (error) {
      SWIFT_DEBUG_LOGGING ? console.error('We weren\'t able to confirm your account. Your link may have expired.', error) : null;
      document.querySelector('#signInError').innerText = error.message;
    }
  }

  replaceSpaceWithPlus(str) {
    return str ? str.replace(/ /g, '+') : '';
  }

  goToLastViewedPageBeforeLogin() {
    window.location.href = window.location.origin + this.getLastAddedPage();
  }

  getLastAddedPage() {
    // ... implementation for getting the last added page
    var visitedPages = JSON.parse(localStorage.getItem("visitedPages")) || [];
    return visitedPages.length > 0 ? visitedPages[visitedPages.length - 1] : "/";	
  }

  registerConversion() {
    // ... implementation for tracking registration conversion
  }

  confirmAccountConversion() {
    // ... implementation for tracking account confirmation conversion
  }

  // ... other methods (add as needed)
  async deleteProfile() {
    SWIFT_DEBUG_LOGGING ? console.info('deleteProfile') : null;
    // confirm the user wants to delete their profile
    let okayDelete = confirm('Are you sure you want to delete your profile? This cannot be undone.');
    if (!okayDelete) {
        return;
    }
    // get the current session
    const session = await Auth.currentSession();
    // if there is a session, delete the user
    if (session) {
        // delete the user
        Auth.currentAuthenticatedUser()
            .then(user => {
                return Auth.deleteUser(user);
            })
            .then((data) => {
              SWIFT_DEBUG_LOGGING ? console.info(data) : null;
            })
            .catch(err => {
                SWIFT_DEBUG_LOGGING ? console.error(err) : null;
            });
    }
    else {
        return; // if there is no session, do nothing
    }
  }


async deleteOnboardingAttribute() {
    try {
        SWIFT_DEBUG_LOGGING ? console.info('try deleteOnboardingAttribute') : null;
        const attributesToDelete = ['custom:sendToOnboarding'];
        // get current user then delete the attribute
        await Auth.currentAuthenticatedUser().then(user => {
            Auth.deleteUserAttributes(user, attributesToDelete)
                .then((data) => {
                  SWIFT_DEBUG_LOGGING ? console.info('deleted sendToOnboarding, data', data) : null;
                })
                .catch((err) => {
                  SWIFT_DEBUG_LOGGING ? console.error('error deleting sendToOnboarding, err ', err) : null;
                });
        });
    } catch (error) {
        SWIFT_DEBUG_LOGGING ? console.error('catch, could not delete sendToOnboarding', error) : null;
    }
}



async setAttribute(attributeName, passedValue) {
    try {
        SWIFT_DEBUG_LOGGING ? console.info('setAttribute', attributeName, passedValue) : null;
        const user = await Auth.currentAuthenticatedUser();
        const attributes = await Auth.userAttributes(user);
        const attribute = attributes.find(attribute => attribute.Name === attributeName);
        SWIFT_DEBUG_LOGGING ? console.info('attribute', attribute) : null;
        if (attribute !== passedValue) {
            Auth.updateUserAttributes(user, {
                [attributeName]: passedValue
            });
        }
    } catch (error) {
        SWIFT_DEBUG_LOGGING ? console.error(error) : null;
    }
}

async getAttribute(attributeName) {
    try {
        SWIFT_DEBUG_LOGGING ? console.info('getAttribute', attributeName) : null;
        const user = await Auth.currentAuthenticatedUser();
        const attributes = await Auth.userAttributes(user);
        const attribute = attributes.find(attribute => attribute.Name === attributeName);
        SWIFT_DEBUG_LOGGING ? console.info('attribute', attribute) : null;
        return attribute ? attribute : '';
    } catch (error) {
        SWIFT_DEBUG_LOGGING ? console.error(error) : null;

    }
}



setupOnboarding() {
  this.cacheOnboardingDomElements();
  this.hideInitialElements();
  this.setupProgressIndicator();
  this.setupAutoCapitalization();
  this.setupEnterKeySubmit();
  this.profileUserData();
  this.attachOnboardingEventListeners();
}

cacheOnboardingDomElements() {
  this.dom.onboardingNameInput = document.querySelector('#name');
  this.dom.onboardingPostalCodeInput = document.querySelector('#postal_code');
  this.dom.firstSubmitButton = document.querySelector('#firstsubmit');
  this.dom.secondSubmitButton = document.querySelector('#secondsubmit');
  this.dom.thirdSubmitButton = document.querySelector('#thirdsubmit');
  this.dom.fourthSubmitButton = document.querySelector('#fourthsubmit');
  // ... other onboarding DOM elements
}

hideInitialElements() {
  // document.querySelector('h1').style.display = 'none';
  document.querySelector('#second').style.display = 'none';
  document.querySelector('#third').style.display = 'none';
  document.querySelector('#fourth').style.display = 'none';
}

setupProgressIndicator() {
  const progressBarHtml = '<div class="progress"><div class="progress-bar" role="progressbar" style="width: 0%;"></div></div>';
  document.querySelector('header').insertAdjacentHTML('beforeend', progressBarHtml);
  document.querySelector('.progress-bar').style.width = '30%';
}

setupAutoCapitalization() {
  this.dom.onboardingNameInput.addEventListener('keyup', () => {
    this.dom.onboardingNameInput.value =
      this.dom.onboardingNameInput.value.charAt(0).toUpperCase() +
      this.dom.onboardingNameInput.value.slice(1);
  });
}

setupEnterKeySubmit() {
  document.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      switch (this.currentOnboardingStep) {
        case 1:
          this.dom.firstSubmitButton.click();
          break;
        case 2:
          this.dom.secondSubmitButton.click();
          break;
        case 3:
          this.dom.thirdSubmitButton.click();
          break;
        case 4:
          this.dom.fourthSubmitButton.click();
          break;
      }
    }
  });
}


async profileUserData() {
  const name = await this.getAttribute('name');
  if (name && name.Value) {
    this.dom.onboardingNameInput.value = name.Value;
  }

  const address = await this.getAttribute('address');
  if (address && address.Value) {
    const parsedAddress = JSON.parse(address.Value);
    this.dom.onboardingPostalCodeInput.value = parsedAddress.address.postal_code || '';
  }
  
}

attachOnboardingEventListeners() {
  this.dom.firstSubmitButton.addEventListener('click', this.handleFirstSubmit.bind(this));
  this.dom.secondSubmitButton.addEventListener('click', this.handleSecondSubmit.bind(this));
  this.dom.thirdSubmitButton.addEventListener('click', this.handleThirdSubmit.bind(this));
  this.dom.fourthSubmitButton.addEventListener('click', this.handleFourthSubmit.bind(this));
}


handleFirstSubmit() {
  this.currentOnboardingStep = 2;
  document.querySelector('.progress-bar').style.width = '60%';
  window.scrollTo(0, 0);

  const user = {
    name: this.dom.onboardingNameInput.value,
    address: {
      address: {
        postal_code: this.dom.onboardingPostalCodeInput.value,
        // formatted: '',
        // street_address: '',
        // locality: '',
        // region: '',
        // country: '',
      },
    },
  };

  this.setAttribute('name', user.name);
  this.setAttribute('address', JSON.stringify(user.address));

  document.querySelector('#secondname').textContent = `${user.name}!`;
  document.querySelector('#fourthname').textContent = `${user.name}!`;

  document.querySelector('#first').style.display = 'none';
  document.querySelector('#second').style.display = 'block';

  setTimeout(() => {
    const checkboxes = document.querySelectorAll('.newsletter-checkbox');
    for (let i = 0; i < 2; i++) {
      if (!checkboxes[i].checked) {
        checkboxes[i].click();
      }
    }
  }, 500);

//   $(".newsletter-checkbox").on("click", async function () {
//     try {
//       const user = await Auth.currentAuthenticatedUser();
//       const email = user.attributes.email;

//       var fieldID = $(this).attr("id");
//       var checked = $(this).is(":checked");
//       var requestType = "POST";
//       var action = "update_subscriptions";
//       var ajaxurl = "/wp-admin/admin-ajax.php";

//       $.ajax({
//           type: requestType,
//           url: ajaxurl,
//           dataType: "json",
//           data: {
//               action: action,
//               fieldID: fieldID,
//               email: email,
//               checked: checked
//           },
//           success: function (response) {

//               $("#" + fieldID).parent().parent().parent().css("background-color", "#c3e6cb");

//               setTimeout(function () {
//                   $("#" + fieldID).parent().parent().parent().css("background-color", "#fff"); // fade out
//               }, 1000);
//           },
//           error: function (errorThrown) {
//               SWIFT_DEBUG_LOGGING ? console.error("Error setting newsletter choice, response: " + errorThrown) : null;

//               $("#" + fieldID).parent().parent().parent().css("background-color", "#f5c6cb");

//               setTimeout(function () {
//                   $("#" + fieldID).parent().parent().parent().css("background-color", "#fff"); // fade out
//               }, 1000);
//           },
//       });

//     } catch (error) {
//       SWIFT_DEBUG_LOGGING ? console.error(error) : null;
//   }

//   // call the endpoint to get the current user's subscriptions
//   // email


// });
document.querySelectorAll(".newsletter-checkbox").forEach(function(checkbox) {
    checkbox.addEventListener("click", async function() {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const email = user.attributes.email;

            var fieldID = this.id;
            var checked = this.checked;
            var requestType = "POST";
            var action = "update_subscriptions";
            var ajaxurl = "/wp-admin/admin-ajax.php";

            fetch(ajaxurl, {
                method: requestType,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    action: action,
                    fieldID: fieldID,
                    email: email,
                    checked: checked
                })
            })
            .then(response => response.json())
            .then(data => {
                var parentElement = document.getElementById(fieldID).closest('div'); // Adjust selector to match the closest parent
                parentElement.style.backgroundColor = "#c3e6cb";

                setTimeout(function() {
                    parentElement.style.backgroundColor = "#fff"; // fade out
                }, 1000);
            })
            .catch(error => {
                if (SWIFT_DEBUG_LOGGING) {
                    console.error("Error setting newsletter choice, response: " + error);
                }

                var parentElement = document.getElementById(fieldID).closest('div'); // Adjust selector to match the closest parent
                parentElement.style.backgroundColor = "#f5c6cb";

                setTimeout(function() {
                    parentElement.style.backgroundColor = "#fff"; // fade out
                }, 1000);
            });

        } catch (error) {
            if (SWIFT_DEBUG_LOGGING) {
                console.error(error);
            }
        }

        // call the endpoint to get the current user's subscriptions
        // email
    });
});


}

handleSecondSubmit() {
  this.currentOnboardingStep = 3;
  document.querySelector('.progress-bar').style.width = '90%';
  window.scrollTo(0, 0);

  const topics = Array.from(document.querySelectorAll('input[type=checkbox]:checked')).map(
    (checkbox) => checkbox.value
  );

  // ... (logic for handling topics)

  document.querySelector('#second').style.display = 'none';
  document.querySelector('#third').style.display = 'block';
}

handleThirdSubmit() {
  this.currentOnboardingStep = 4;
  document.querySelector('.progress-bar').style.width = '100%';
  window.scrollTo(0, 0);

  const interests = Array.from(document.querySelectorAll('button'))
    .filter((button) => button.textContent === 'Follow')
    .map((button) => button.previousElementSibling.textContent);

  // ... (logic for handling interests)

  document.querySelector('#third').style.display = 'none';
  document.querySelector('#fourth').style.display = 'block';

  this.deleteOnboardingAttribute();

  setTimeout(() => {
    window.location.href = '/';
  }, 2000);
}

handleFourthSubmit() {
  document.querySelector('.progress-bar').style.width = '100%';
  window.scrollTo(0, 0);

  this.deleteOnboardingAttribute();

  setTimeout(() => {
    window.location.href = '/';
  }, 500);
}

async getUserEmail() {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user.attributes.email;
  }
  catch(error) {
    SWIFT_DEBUG_LOGGING ? console.error('Error getting user email', error) : null;
  }
}

async linkToNewsletterPageFromHomepageNewsletterModule() {
  try {
    const user = await Auth.currentAuthenticatedUser();
    // return user.attributes.email;
    window.location.href = '/newsletter-subscriptions/?email=' + user.attributes.email;
  } catch (error) {
    SWIFT_DEBUG_LOGGING ? console.error('Error navigating to newsletter-subscriptions page, user may not be logged in or have an email on file.', error) : null;
  }
}

// google analytics 4 tagID from swift site config call from theme
async  addGA4LoggedInUsers(tagID) {
// maybe we get the tagID from a function in the swift news theme?

  // SWIFT_DEBUG_LOGGING ? console.info('add GA4 user ID', tagID) : null;
  await Auth.currentAuthenticatedUser().then(user => {
      return user.attributes.sub;
  })
  .then(sub => {

      if (sub == null) {
          if (window.location.hostname.includes('dev.')) {
              gtag('set', 'user_properties', {
                  dev_testdimension: 'Dev site signed out'
              });
          }
          // return;
      }
      // send the sub as the userID to GA4
      gtag('config', tagID, {
          'user_id': sub
      });

      // if the domain is 'dev.' or '.local' add a custom dimension
      if (window.location.hostname.includes('dev.') || window.location.hostname.includes('.local')) {
          gtag('set', 'user_properties', {
              dev_testdimension: 'Dev site signed in',
              'user_id': sub
          });
      }

      SWIFT_DEBUG_LOGGING ? console.info('added GA4 user ID: ', sub) : null;

  })
  .catch(error => {
      // return the error
      console.warn('Cannot add GA4 user ID to GA', error);
  });

}



// Swiftcognito.getAttribute = getAttribute;

  // async onboarding() {

  //       // hide the h1 tag
  //       $('h1').hide();
  //       // autofocus the name input after 100ms
  //       setTimeout(function () {
  //         $('#name').trigger('focus');
  //       }, 200);

  //       $('header').append('<div class="progress"><div class="progress-bar" role="progressbar" style="width: 0%;"></div></div>');
  //       // auto capitalize the first letter of the name
  //       $('#name').on('keyup', function () {
  //           $(this).val($(this).val().charAt(0).toUpperCase() + $(this).val().slice(1));
  //       });
  //       $('.progress-bar').css('width', '30%');

  //       $(document).on('keypress', function (e) {
  //           if (e.which == 13) {
  //               $('#firstsubmit').trigger('click');
  //           }
  //       });

  //       $('#first').show();
  //       $('#second').hide()
  //       $('#third').hide();
  //       $('#fourth').hide();

  //       // populate the name input with the user's name from the session
  //       let username = await getAttribute('name');
  //       username.then(function (result) {
  //           SWIFT_DEBUG_LOGGING ? console.info('username', result) : null;
  //           if (result) {
  //               // make the result.Value titlecase
  //               let titlecase = result.Value.charAt(0).toUpperCase() + result.Value.slice(1);
  //               $('#name').val(titlecase);
  //           }
  //           else {
  //               SWIFT_DEBUG_LOGGING ? console.info('no name attribute, ask user for name') : null;
  //           }
  //       });

  //       let address = await getAttribute('address');
  //       address.then(function (result) {
  //           SWIFT_DEBUG_LOGGING ? console.info('address 2', result) : null;

  //           if (result !== '' && result !== 'undefined') {

  //               address = JSON.parse(result.Value);
  //               let postal_code = address.address.postal_code || '';
  //               SWIFT_DEBUG_LOGGING ? console.info('postal_code', postal_code) : null;
  //               document.querySelector('#postal_code').value = postal_code;
  //           }
  //           else {
  //               SWIFT_DEBUG_LOGGING ? console.info('no postal_code attribute, ask user for postal_code') : null;
  //           }
  //       });

  //       let user = {};

  //       $('#firstsubmit').on('click', function () {
  //           $('.progress-bar').css('width', '60%');
  //           // scroll the window to the top of the page to start fresh
  //           window.scrollTo(0, 0);

  //           $(document).on('keypress', function (e) {
  //               if (e.which == 13) {
  //                   $('#secondsubmit').click();
  //               }
  //           });

  //           user.name = $('#name').val();

  //           // set the attribute for the user
  //           setAttribute('name', user.name, function () {
  //               SWIFT_DEBUG_LOGGING ? console.info('name set') : null;
  //           });


  //           localStorage.setItem('user', JSON.stringify(user));

  //           user = JSON.parse(localStorage.getItem('user'));

  //           // SET ADDRESS
  //           // get zipcode from input id="zipcode"
  //           let postal_code = $('#postal_code').val();
  //           // set the attribute for the user
  //           let address = {
  //               "address": {
  //                   "formatted": "",
  //                   "street_address": "",
  //                   "locality": "",
  //                   "region": "",
  //                   "postal_code": postal_code,
  //                   "country": ""
  //               }
  //           };
  //           // get the data from local storage
  //           user = JSON.parse(localStorage.getItem('user'));
  //           // save the data to the user object
  //           user.address = address;
  //           // save the user object to local storage
  //           localStorage.setItem('user', JSON.stringify(user));

  //           address = JSON.stringify(address);

  //           setAttribute('address', address, function () {
  //               SWIFT_DEBUG_LOGGING ? console.info('postal_code set') : null;
  //           });


  //           // update hi name!
  //           $('#secondname').text(user.name + "!");
  //           $('#fourthname').text(user.name + "!");

  //           // switch to the next div
  //           $('#first').hide();
  //           $('#second').show();

  //           // wait a second
  //           setTimeout(function () {
  //               // check the first two checkboxes with .newsletter-checkbox
  //               $('.newsletter-checkbox').each(function (index) {
  //                   // if prop is not checked, check it
  //                   if (index < 2 && !$(this).is(':checked')) {
  //                       $(this).click();
  //                   }
  //               });
  //           }, 500);

  //       });

  //       $('#secondsubmit').on('click', function () {
  //           $('.progress-bar').css('width', '90%');
  //           // scroll the window to the top of the page to start fresh
  //           window.scrollTo(0, 0);

  //           $(document).on('keypress', function (e) {
  //               if (e.which == 13) {
  //                   $('#thirdsubmit').trigger('click');
  //               }
  //           });
  //           // get the data from local storage
  //           user = JSON.parse(localStorage.getItem('user'));
  //           // get the data from the checkboxes
  //           let topics = [];
  //           $('input[type=checkbox]').each(function () {
  //               if ($(this).is(':checked')) {
  //                   topics.push($(this).val());
  //               }
  //           });
  //           // save the data to the user object
  //           user.topics = topics;
  //           // save the user object to local storage
  //           localStorage.setItem('user', JSON.stringify(user));
  //           // redirect to the next page
  //           $('#second').hide();
  //           $('#third').show();
  //       });

  //       $('#thirdsubmit').on('click', function () {
  //           $('.progress-bar').css('width', '100%');
  //           // scroll the window to the top of the page to start fresh
  //           window.scrollTo(0, 0);

  //           $(document).on('keypress', function (e) {
  //               if (e.which == 13) {
  //                   $('#fourthsubmit').trigger('click');
  //               }
  //           });
  //           // get the data from local storage
  //           user = JSON.parse(localStorage.getItem('user'));
  //           // get the data from the follow buttons
  //           let interests = [];
  //           $('button').each(function () {
  //               if ($(this).text() == 'Follow') {
  //                   interests.push($(this).prev().text());
  //               }
  //           });
  //           // save the data to the user object
  //           user.interests = interests;
  //           // save the user object to local storage
  //           localStorage.setItem('user', JSON.stringify(user));
  //           // redirect to the next page
  //           $('#third').hide();
  //           $('#fourth').show();

  //           // delete the onboarding custom attribute:sendToOnboarding in user OIDC profile so they don't get looped back to onboarding
  //           deleteOnboardingAttribute();

  //           setTimeout(function () {
  //               window.location.href = '/';
  //           }, 2000);

  //       });

  //       $('#fourthsubmit').on('click', function () {
  //           $('.progress-bar').css('width', '100%');
  //           // scroll the window to the top of the page to start fresh
  //           window.scrollTo(0, 0);

  //           // delete the onboarding custom attribute:sendToOnboarding in user OIDC profile so they don't get looped back to onboarding
  //           deleteOnboardingAttribute();

  //           // redirect to the next page
  //           $('#fourth').hide();

  //           setTimeout(function () {
  //               // delete the onboarding value in user attributes
  //               // deleteUserAttributeSendToOnboarding();
  //               // get the data from local storage
  //               window.location.href = '/';
  //           }, 500);

  //       });


  //   }
}

// Initialize SwiftCognito after DOM is ready
document.addEventListener('DOMContentLoaded', () => {

    // get an instance
    const swiftcognito = new SwiftCognito();

    // Swiftcognito.toggleBookmark = toggleBookmark; Export for use in outsite scripts
    // const toggleBookmark = swiftcognito.toggleBookmark.bind(swiftcognito);
    // window.swifttoggleBookmark = swiftcognito.toggleBookmark;

    // Swiftcognito.getUserEmail = getUserEmail;
    const linkToNewsletterPageFromHomepageNewsletterModule = swiftcognito.linkToNewsletterPageFromHomepageNewsletterModule.bind(swiftcognito);
    window.linkToNewsletterPageFromHomepageNewsletterModule = linkToNewsletterPageFromHomepageNewsletterModule;

    const getUserEmail = swiftcognito.getUserEmail.bind(swiftcognito);
    window.getUserEmail = getUserEmail;

    // Swiftcognito.loginFromWeb = loginFromWeb;
    const loginFromWeb = swiftcognito.loginFromWeb.bind(swiftcognito);
    window.swiftloginFromWeb = loginFromWeb;
    
    // Swiftcognito.registerFromWeb = registerFromWeb;
    const registerFromWeb = swiftcognito.registerFromWeb.bind(swiftcognito);
    window.swiftregisterFromWeb = registerFromWeb;

    // Swiftcognito.addGA4LoggedInUsers = addGA4LoggedInUsers;
    const addGA4LoggedInUsers = (tagID) => {
      return swiftcognito.addGA4LoggedInUsers(tagID).bind(swiftcognito);
    };
    window.swiftaddGA4LoggedInUsers = addGA4LoggedInUsers;
  


    if (window.location.pathname.includes('myprofile')) {

      // Swiftcognito.getProfileData = getProfileData; Export for use in outsite scripts
      const getProfileData = swiftcognito.getProfileData.bind(swiftcognito);
      window.swiftgetProfileData = getProfileData;
  
      // delete the user profile. Export for use in outsite scripts
      const deleteProfile = swiftcognito.deleteProfile.bind(swiftcognito);
      window.swiftdeleteProfile = deleteProfile;

      // get the user profile data
      swiftcognito.getProfileData();

      // if the user hits enter on the profile page while updating thir profile, update the profile
      // $(document).on('keydown', function (event) {
      //   if (event.which == 13) {
      //       event.preventDefault();
            
      //       swiftcognito.updateOpenIDProfile();
      //   }
      // });
    }

});

// How to handle login: business logic.
// If the user is not logged in, check for a persistent cookie. In the persistent cookie, there is a user ID.
// If the cookie is present, try to log in with the cookie. This could be a session cookie or a persistent cookie. This could be a registered user or an anonymous user returning to the site.
// If the cookie is not present, register with an anonymous user.
// When the user registers or logs in, create a session cookie, and link their anonymous user to their registered user.
// When the user logs out, delete the session cookie, and leave the persistent cookie in place.
